import React from 'react';
import RadioDualComponent from 'shared/components/RadioDualComponent';

const DoubleSidedSmt = (props) => {
  const name = 'double_sided_smt';

  const {
    label,
    parameters,
    onChangeParameter,
    groupName,
    required,
    tooltip,
    className,
    disabled,
  } = props;

  const onChange = (e) => onChangeParameter(name, e.target.value);

  return (
    <RadioDualComponent
      name={name}
      label={label}
      tooltip={tooltip}
      onChange={onChange}
      parameters={parameters}
      className={className}
      disabled={disabled}
      required={required}
      groupName={groupName} />
  );
};

DoubleSidedSmt.defaultProps = {
  inputId: 'double-sided-smt',
  label: Spree.translations.parameters.double_sided_smt,
  tooltip: Spree.helpForParameters.double_sided_smt,
};

export default DoubleSidedSmt;
